module.exports = __webpack_public_path__ + "static/media/background.67907ea8.jpg";